import { useTranslation } from 'react-i18next';

export default function OurStory() {
  const { t } = useTranslation();
  return (
    <section id="our-story" className="w-full bg-background-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left - Image Grid */}
          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="grid grid-cols-2 gap-3 md:gap-4">
              <div className="col-span-2">
                <img
                  src="https://readdy.ai/api/search-image?query=Vietnamese%20local%20guide%20talking%20with%20group%20of%20international%20tourists%20at%20a%20traditional%20village%20market%20sharing%20stories%20smiling%20warm%20atmosphere%20travel%20photography%20authentic%20cultural%20exchange%20natural%20lighting&width=800&height=450&seq=about-story-01&orientation=landscape"
                  alt={t('about.storyAlt1')}
                  className="w-full h-56 md:h-64 object-cover rounded-2xl"
                />
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Vietnamese%20travel%20team%20meeting%20together%20discussing%20tour%20planning%20around%20wooden%20table%20with%20maps%20and%20laptops%20warm%20genuine%20teamwork%20atmosphere%20cozy%20office%20setting%20natural%20light%20candid%20moment&width=400&height=400&seq=about-story-02&orientation=squarish"
                  alt={t('about.storyAlt2')}
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
              <div>
                <img
                  src="https://readdy.ai/api/search-image?query=Happy%20international%20tourist%20couple%20enjoying%20Vietnamese%20street%20food%20experience%20guided%20by%20local%20expert%20at%20bustling%20Hanoi%20street%20food%20scene%20evening%20lanterns%20warm%20atmosphere%20travel%20joy&width=400&height=400&seq=about-story-03&orientation=squarish"
                  alt={t('about.storyAlt3')}
                  className="w-full h-40 md:h-48 object-cover rounded-2xl"
                />
              </div>
            </div>
          </div>

          {/* Right - Text */}
          <div className="flex-1">
            <p className="text-accent-500 font-body text-sm tracking-wide uppercase mb-2">{t('about.storyEyebrow')}</p>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-secondary-900 leading-tight mb-5">
              {t('about.storyTitleA')}<br />
              <span className="text-accent-500">{t('about.storyTitleB')}</span>
            </h2>
            <div className="space-y-4 text-secondary-600 text-sm md:text-base leading-relaxed">
              <p>
                {t('about.storyP1')}
              </p>
              <p>
                {t('about.storyP2')}
              </p>
              <p>
                {t('about.storyP3')}
              </p>
            </div>
            <div className="mt-6 p-4 bg-accent-50 border-l-4 border-accent-500 rounded-r-lg">
              <p className="text-secondary-700 text-sm italic leading-relaxed">
                {t('about.quote')}
              </p>
              <p className="text-accent-600 text-xs font-medium mt-2">Nguyen Minh Tuan, Founder &amp; CEO</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}